import { render, staticRenderFns } from "./ClientProductService.vue?vue&type=template&id=070f6d79&"
import script from "./ClientProductService.js?vue&type=script&lang=js&"
export * from "./ClientProductService.js?vue&type=script&lang=js&"
import style0 from "./ClientProductService.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports